import AdminLayout from "../../components/admin/layout/AdminLayout";
import ProfilePage from "../../components/admin/profile/Profile";

function Profile() {
  return (
    <AdminLayout>
      <ProfilePage />
    </AdminLayout>
  );
}

export default Profile;
